import React from 'react';
import { Link } from 'react-router-dom';
import BmbCta from '../BmbCta';
import MkIcon from '../MkIcon';
import MkPhone from '../MkPhone';
import MkPill from '../MkPill';
import bmbBreathing from '../../../assets/images/mk/mk-bmb-breathing-540.webp';
import bmbChoice from '../../../assets/images/mk/mk-bmb-choice-540.webp';
import bmbIntention from '../../../assets/images/mk/mk-bmb-intention-540.webp';
import bmbIcon from '../../../assets/images/mk/mk-bmb-icon-192.webp';
import { mkTrack } from '../../../marketing/track';

const FEATURES = [
  {
    icon: 'hand',
    title: 'Pause before you open',
    body: 'Choose up to 3 apps for free, or unlimited with Premium. When you open one, take a breath, then continue or step away.',
  },
  {
    icon: 'breath',
    title: 'Seven ways to pause',
    body: '4-7-8 breathing, a quote and a 15-second delay are free. Box breathing, intention, 5-4-3-2-1 grounding and gratitude come with Premium.',
  },
  {
    icon: 'globe',
    title: 'Block sites on your phone',
    body: 'Adult content is blocked for free. Add the sites that pull you in with Premium. Filtering stays on your device.',
  },
  {
    icon: 'heatmap',
    title: 'See your patterns',
    body: 'A daily streak for free; history, an activity heatmap and insights with Premium.',
  },
];

// H7 — Bring Me Back spotlight. No BMB numbers, ratings or reviews anywhere.
const HomeBmb = ({ platform }) => (
  <section className="mk-bmbspot section" id="bring-me-back" aria-labelledby="mk-bmbspot-title">
    <div className="container">
      <div className="mk-bmbspot__inner section-inner">
        <div className="mk-bmbspot__text">
          <p className="mk-eyebrow mk-bmbspot__eyebrow">
            <MkPill variant="new">New</MkPill>
            <span>The companion app</span>
          </p>
          <h2 id="mk-bmbspot-title" className="mk-h2">
            For the moments your phone is unlocked.
          </h2>
          <p className="mk-lead">
            Keep Me Out is the wall. Bring Me Back is the nudge: a short, mindful pause before the apps that pull you in —
            on iPhone and Android.
          </p>
          <ul className="list-reset mk-bmbspot__list">
            {FEATURES.map((f, i) => (
              <li
                key={f.title}
                className="mk-bmbspot__item reveal-from-bottom"
                data-reveal-container=".mk-bmbspot__list"
                data-reveal-delay={i * 80}
              >
                <span className="mk-icon-tile mk-icon-tile--bmb">
                  <MkIcon name={f.icon} />
                </span>
                <div>
                  <h3 className="mk-h3">{f.title}</h3>
                  <p className="mk-body">{f.body}</p>
                </div>
              </li>
            ))}
          </ul>
          <p className="mk-card mk-setup-note">
            <MkIcon name="info" size={20} />
            <span>
              Setup: on Android, switch on Accessibility once. On iPhone, add a Shortcuts automation for each app — the
              app shows you how.
            </span>
          </p>
        </div>

        <div className="mk-bmbspot__visual reveal-scale-up">
          <div className="mk-drift">
            <div className="mk-bmbspot__stage">
              <span className="mk-bmbspot__disc" aria-hidden="true" />
              {/* The pause flow as a fan: ask (left) → breathe (front) → decide (right). Backs are decorative. */}
              <div className="mk-bmbspot__phone mk-bmbspot__phone--back" aria-hidden="true">
                <MkPhone src={bmbIntention} width={540} height={1095} framed alt="" />
              </div>
              <div className="mk-bmbspot__phone mk-bmbspot__phone--back mk-bmbspot__phone--right" aria-hidden="true">
                <MkPhone src={bmbChoice} width={540} height={1095} framed alt="" />
              </div>
              <div className="mk-bmbspot__phone mk-bmbspot__phone--front">
                <div className="mk-float">
                  <MkPhone
                    src={bmbBreathing}
                    width={540}
                    height={1095}
                    framed
                    alt={'Bring Me Back breathing pause before Facebook, reading "Breathe out"'}
                  />
                </div>
              </div>
              <img
                className="mk-bmbspot__icon"
                src={bmbIcon}
                alt=""
                width={72}
                height={72}
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>

        <div className="mk-bmbspot__cta">
          <BmbCta
            placement="home_bmb"
            platform={platform}
            variant={platform === 'ios' ? 'button' : 'badges'}
          />
          <p className="mk-micro mk-bmbspot__naming">Listed as "BringMeBack" on the App Store and Google Play.</p>
          <Link
            className="mk-textlink"
            to="/bring-me-back"
            onClick={() => mkTrack('cta_click', 'bmb_page:home_bmb_explore')}
          >
            Explore Bring Me Back →
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default HomeBmb;
